<template>
  <nav
    role="navigation"
    class="i-nav"
  >
    <!-- mobile inner -->
    <div
      class="i-nav-mobile-inner"
      :class="{ 'i-nav-mobile-inner-active': isMobileMenuActive }"
    >
      <div class="nav-list">
        <i-repeat
          class="i-nav-mobile-inner-icon-wrapper"
          :items="isClickAvatar ? avatarList : navMobileInnerList"
        >
          <template #default="{ item }">
            <div
              :class="`menu-item-area ${item.customClass || ''}`"
              @click.prevent="item.method"
            >
              <button
                class="i-repeat-a"
                role="button"
                :class="{
                  'icon-disabled': item.disabled
                }"
                :aria-label="item.caption"
              >
                <span class="i-repeat-icon-wrapper">
                  <svg-icon
                    :name="item.name"
                    :class="`i-repeat-icon icon-${item.name}${
                      item.isActive ? ' icon-active' : ''
                    }`"
                    color="#000000"
                  />
                </span>
                <span
                  class="i-repeat-text"
                  style="color: #000"
                >{{
                  item.caption
                }}</span>
              </button>
            </div>
          </template>
        </i-repeat>
      </div>
      <ul
        v-if="showPoweredBy && !isUiMode"
        class="i-nav-policy"
      >
        <li>
          <a
            class="footer-text"
            href="https://www.istaging.com/legal/terms_of_service"
            target="_blank"
          >
            <span>Terms of use</span>
          </a>
        </li>
        <li>
          <a
            class="footer-text"
            href="https://www.istaging.com/legal/privacy_policy"
            target="_blank"
          >
            <span>Privacy policy</span>
          </a>
        </li>
        <li>
          <a
            class="footer-text"
            href="https://www.istaging.com"
            target="_blank"
          >
            <span>Powered by iStaging</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- pc -->
    <div class="i-nav-pc">
      <div
        v-show="currentBuilding.homeButtonEnable"
        v-tooltip.bottom="{
          content: isFloatMenuActive ? '' : $t('returnToFirstPanorama'),
        }"
        class="i-nav-pc-home-wrapper"
        @click="homeIconClick"
      >
        <i class="isif isif-home home-icon" />
      </div>
      <div
        v-tooltip.bottom="{
          content: isFloatMenuActive ? '' : $t('otherFunctions'),
        }"
        class="i-nav-pc-expand-wrapper expand-btn"
        :class="isFloatMenuActive ? 'active' : ''"
        @click="showFloatMenu"
      >
        <i class="isif isif-expand expand-icon" />
      </div>
      <div
        v-show="isFloatMenuActive"
        class="i-nav-pc-icon-wrapper"
      >
        <template v-for="(group, index) in navPcGruopedList">
          <div :key="index">
            <i-repeat :items="group">
              <template #default="{ item }">
                <div
                  :class="`menu-item-area i-nav-pc-li-inner ${
                    item.customClass || ''
                  }`"
                  @click.prevent="item.method"
                >
                  <button
                    role="button"
                    class="i-repeat-a i-repeat-a-horizontal"
                    :class="{
                      'icon-disabled': item.disabled
                    }"
                    :aria-label="item.caption"
                  >
                    <span
                      class="i-repeat-icon-wrapper"
                      :style="item.iconWrapperStyle"
                    >
                      <svg-icon
                        :name="item.name"
                        :class="`i-repeat-icon icon-${item.name}${
                          item.isActive ? ' icon-active' : ''
                        }`"
                        :color="icon[item.name].color"
                      />
                    </span>
                  </button>
                  <span class="item-caption">{{ item.caption }}</span>
                </div>
              </template>
            </i-repeat>
            <div
              v-if="index !== (navPcGruopedList.length - 1)"
              v-show="group.length"
              class="menu-group-last-item-line"
            />
          </div>
        </template>
      </div>
      <modal-profile ref="ModalProfile" />
      <modal-booking
        ref="ModalBooking"
        :company="profile.companyDisplayName || $t('None')"
        :calendar="currentBuilding.calendar"
        :bookings="currentBuilding.bookings"
      />
    </div>
    <chat-box
      v-if="showChatBox"
      custom-class="chat-box"
    />
  </nav>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { isIframe, isMobile, isIOS } from '@/api/utils'
import IRepeat from '@/components/IRepeat.vue'
import SvgIcon from '@/components/SvgIcon/index.vue'
import HandleData from '@/mixins/HandleData.vue'
import queryString from '@/api/query-string'
import { yachtBuildingId } from '~js/constants'
import { MODALS } from '@/components/VrLounge'
import ModalProfile from '../../components/common/modals/ModalProfile/index.vue'
import ModalBooking from '../../components/common/modals/ModalBooking/index.vue'
import ChatBox from '../../components/InstantMessaging/ChatBox.vue'
import webStorage from '../../store/webStorage/helper'
import { isHeadset } from '../../api/utils'

export default {
  name: 'INav',
  components: {
    ChatBox,
    ModalBooking,
    ModalProfile,
    IRepeat,
    SvgIcon
  },

  mixins: [HandleData],
  data () {
    return {
      defaultColor: '#fff',
      icon: {
        // information: { color: this.defaultColor },
        comment: { color: this.defaultColor },
        fullscreen: { color: this.defaultColor },
        gyro: { color: this.defaultColor },
        like: { color: this.defaultColor },
        location: { color: this.defaultColor },
        music: { color: this.defaultColor },
        musicOff: { color: this.defaultColor },
        qrcode: { color: this.defaultColor },
        share: { color: this.defaultColor },
        pilot: { color: this.defaultColor },
        map: { color: this.defaultColor },
        floorplan: { color: this.defaultColor },
        panoSelect: { color: this.defaultColor },
        vrmode: { color: this.defaultColor },
        showMobileMenu: { color: this.defaultColor },
        website: { color: this.defaultColor },
        search: { color: this.defaultColor },
        home: { color: this.defaultColor },
        expand: { color: this.defaultColor },
        narratorProfile: { color: this.defaultColor },
        talk: { color: this.defaultColor },
        inforCard: { color: this.defaultColor },
        calendar: { color: this.defaultColor },
        startPolit: { color: this.defaultColor },
        person: { color: this.defaultColor },
        heart: { color: this.defaultColor },
        logout: { color: this.defaultColor }
      },
      pilotIconStyleMobile: {
        padding: 0
      },
      pilotIconHovered: false,
      isExpoActive: false,
      isAgendaActive: false
    }
  },
  computed: {
    ...mapGetters({
      isFavoritesEnabled: 'favorites/enabled',
      isLogin: 'auth/isLogin',
      profileUrl: 'auth/profileUrl'
    }),
    ...mapGetters([
      'alreadyShownPilotTooltip',
      'showChatBox',
      'isClickAvatar',
      'audioEl',
      'currentBuilding',
      'customSetting',
      'floorplan',
      'isAudioPlaying',
      'isCommentsActive',
      'isPilotListActive',
      'isPilotPlayerActive',
      'isPilotTooltipActive',
      // 'isPilotPlaying',
      'isFloorplanActive',
      'isFullscreen',
      'isGyroEnabled',
      'isGyroFromIframe',
      'isLocationActive',
      'isMobileMenuActive',
      'isPanoramasListActive',
      'isShareActive',
      'isSocialLiked',
      'isSearchActive',
      'isUiMode',
      'isVrMode',
      'pilotList',
      'mainColor',
      'property',
      'showSearch',
      'social',
      'showPoweredBy',
      'isMarkerFinderEnable',
      'panoramas',
      'panorama',
      'currentPanorama',
      'isFloatMenuActive'
    ]),
    shouldPilotPlayerActive () {
      return this.isPilotPlayerActive
    },
    profile () {
      const { showAdminProfile, adminProfile } = this.$store.getters.user
      return showAdminProfile && adminProfile
        ? adminProfile
        : this.$store.getters.user
    },
    customBranding () {
      const { customSetting } = this.profile
      return customSetting.customBranding
    },
    isYacht () {
      return this.$route.params.buildingId === yachtBuildingId
    },
    showProfile () {
      return this.currentBuilding.showContactInfo
    },
    pilotIconWrapperStyleMobile () {
      const style = {
        width: '46px',
        height: '46px',
        borderRadius: '50%'
      }
      if (this.isPilotPlayerActive) {
        style.backgroundColor = this.mainColor
        style.backgroundImage = 'none'
      }
      if (
        this.isPilotPlayerActive &&
        (this.pilotIconHovered || this.isPilotListActive)
      ) {
        style.backgroundColor = '#fff'
        style.backgroundImage = 'none'
      }
      return style
    },

    pilotIconWrapperStylePc () {
      const style = {
        width: '52px',
        height: '52px',
        borderRadius: '50%'
      }
      if (this.isPilotPlayerActive) {
        style.backgroundColor = this.mainColor
        style.backgroundImage = 'none'
      }
      if (
        this.isPilotPlayerActive &&
        (this.pilotIconHovered || this.isPilotListActive)
      ) {
        style.backgroundColor = '#fff'
        style.backgroundImage = 'none'
      }
      return style
    },
    canDeviceSupportGyro () {
      // 1. 不是 IOS 且不是 iframe 時顯示
      // 2. 是 IOS 是 iframe，但是 isGyroFromIframe = true 時顯示
      return (
        isMobile() &&
        (!isIOS() ||
          (isIframe() && this.isGyroFromIframe && isIOS()) ||
          !isIframe())
      )
    },
    avatarList () {
      return [{
        name: 'person',
        caption: this.$t('vrlounge.profile'),
        hidden: !this.isLogin,
        method: () => {
          this.setCurrentModal(MODALS.update)
          this.closeMobileMenu()
        }
      }, {
        name: 'heart',
        caption: this.$t('favorites.title'),
        hidden: !this.isFavoritesEnabled || !this.isLogin,
        customClass: 'menu-item-area-border-bottom',
        method: () => {
          this.showFavoritesDialog()
          this.closeMobileMenu()
        }
      }, {
        name: 'logout',
        caption: this.$t('logOut'),
        hidden: !this.isLogin,
        method: () => {
          this.doLogout()
          this.closeMobileMenu()
        }
      }]
    },
    navMobileInnerList () {
      const list = [{
        name: 'share',
        caption: this.$t('share'),
        hidden: this.isHideShare,
        group: 'noSwitchArea',
        method: () => {
          this.toggleShare()
          this.closeComments()
          this.closeMarkerInfo()
          this.closeLocation()
          this.closeMobileMenu()
        }
      }, {
        name: 'fullscreen',
        caption: this.$t('fullscreen'),
        hidden: this.isHideFullscreen,
        group: 'noSwitchArea',
        method: () => {
          this.closeMobileMenu()
          this.enterFullscreen()
        }
      }, {
        name: 'vrmode',
        caption: this.$t('vrmode'),
        hidden: this.isHideVrmode || this.isPilotPlayerActive,
        group: 'mobileExclusive',
        method: async () => {
          if (await this.getDeviceMotionPermission()) {
            this.closeMobileMenu()
            this.enterVrMode()
          }
        }
      }, {
        name: 'gyro',
        caption: this.$t('gyro'),
        hidden: this.isHideGyro,
        group: 'mobileExclusive',
        method: async () => {
          if (await this.getDeviceMotionPermission()) {
            this.closeMobileMenu()
            this.toggleGyro()
          }
        }
      }, {
        name: 'floorplan',
        caption: this.$t('floorplan'),
        hidden: this.isHideFloorplan,
        group: 'interactionArea',
        method: () => {
          this.toggleFloorplan()
          this.closeMobileMenu()
        }
      }, {
        id: 'pilot-mobile-id',
        name: 'pilot',
        caption: this.$t('pilot'),
        hidden: this.isHidePilot,
        iconWrapperStyle: this.pilotIconWrapperStylePc,
        group: 'interactionArea',
        method: () => {
          this.changeShownPilotTooltipState(true)
          this.shrinkPilotPlayer()
          this.showPilotPlayer()
          this.closeMobileMenu()
          this.$root.$emit('play-pilot')
        }
      },
      {
        name: 'music',
        caption: this.$t('openMusic'),
        hidden: this.isHideMusic || this.isAudioPlaying,
        group: 'interactionArea',
        method: () => {
          this.toggleAudioStatus()
          this.closeMobileMenu()
        }
      },
      {
        name: 'musicOff',
        caption: this.$t('closeMusic'),
        hidden: this.isHideMusic || !this.isAudioPlaying,
        group: 'interactionArea',
        method: () => {
          this.toggleAudioStatus()
          this.closeMobileMenu()
        }
      },
      {
        name: 'calendar',
        caption: this.$t('pilotBooking'),
        hidden: !this.currentBuilding.calendar,
        group: 'contactArea',
        method: () => {
          this.$refs.ModalBooking.show()
          this.closeMobileMenu()
        }
      }
      ]
      if (
        process.env.USE_GOOGLE_MAP &&
        this.customSetting.googleMap &&
        this.currentBuilding.mapEnable
      ) {
        list.push({
          name: 'location',
          caption: this.$t('location'),
          hidden: this.isHideLocation,
          group: 'contactArea',
          method: () => {
            this.showLocation()
            this.closeMobileMenu()
            this.closeComments()
            this.closeShare()
            this.closeMarkerInfo()
          }
        })
      }
      list.push(
        {
          name: 'inforCard',
          caption: this.$t('vrlounge.contactInfo'),
          hidden: !this.currentBuilding.showContactInfo,
          group: 'contactArea',
          method: () => {
            if (!this.customBranding) {
              window.open('https://www.istaging.com', '_blank')
              return
            }
            this.$refs.ModalProfile.show()
            this.closeMobileMenu()
          }
        },
        {
          name: 'talk',
          caption: this.$t('IMServe'),
          hidden: !this.currentBuilding.instantMessagingEnable,
          group: 'contactArea',
          method: () => {
            if (!this.isLogin) {
              this.setCurrentModal(MODALS.login)
              return
            }
            this.toggleChatbox()
            this.closeMobileMenu()
          }
        }
      )
      const filterList = list.filter((item) => !item.hidden)

      const groupList = _.groupBy(filterList, 'group')
      for (const v of Object.values(groupList)) {
        v[v.length - 1].customClass = 'menu-item-area-border-bottom'
      }
      return _.flatMap(groupList)
    },
    navPcList () {
      const list = [{
        name: 'share',
        caption: this.$t('share'),
        hidden: this.isHideShare,
        group: 'noSwitchArea',
        method: () => {
          this.toggleShare()
          this.closeComments()
          this.closeMarkerInfo()
          this.closeLocation()
          this.closeFloatMenu()
        }
      }, {
        name: 'vrmode',
        caption: this.$t('vrmode'),
        hidden: !this.isHeadsetDevice,
        group: 'mobileExclusive',
        method: async () => {
          if (await this.getDeviceMotionPermission()) {
            this.closeMobileMenu()
            this.enterVrMode()
          }
        }
      }, {
        name: 'fullscreen',
        caption: this.$t('fullscreen'),
        hidden: this.isHideFullscreen,
        group: 'noSwitchArea',
        method: () => {
          this.closeMobileMenu()
          this.enterFullscreen()
          this.closeFloatMenu()
        }
      }, {
        name: 'floorplan',
        caption: this.$t('floorplan'),
        hidden: this.isHideFloorplan,
        group: 'interactionArea',
        method: () => {
          this.toggleFloorplan()
          this.closeFloatMenu()
        }
      },
      {
        id: 'pilot-pc-id',
        name: 'pilot',
        caption: this.$t('pilot'),
        hidden: this.isHidePilot,
        group: 'interactionArea',
        method: () => {
          this.changeShownPilotTooltipState(true)
          this.closePilotList()
          this.shrinkPilotPlayer()
          this.showPilotPlayer()
          this.closeFloatMenu()
          this.$root.$emit('play-pilot')
        }
      },
      {
        name: 'music',
        caption: this.$t('openMusic'),
        hidden: this.isHideMusic || this.isAudioPlaying,
        group: 'interactionArea',
        method: () => {
          this.toggleAudioStatus()
          this.closeFloatMenu()
        }
      },
      {
        name: 'musicOff',
        caption: this.$t('closeMusic'),
        hidden: this.isHideMusic || !this.isAudioPlaying,
        group: 'interactionArea',
        method: () => {
          this.toggleAudioStatus()
          this.closeFloatMenu()
        }
      },

      {
        name: 'calendar',
        caption: this.$t('pilotBooking'),
        hidden: !this.currentBuilding.calendar,
        group: 'contactArea',
        method: () => {
          this.$refs.ModalBooking.show()
          this.closeFloatMenu()
        }
      }]

      if (process.env.USE_GOOGLE_MAP && this.currentBuilding.mapEnable) {
        list.push({
          name: 'location',
          caption: this.$t('location'),
          hidden: this.isHideLocation,
          group: 'contactArea',
          method: () => {
            this.toggleLocation()
            this.closeComments()
            this.closeShare()
            this.closeMarkerInfo()
            this.closeFloatMenu()
          }
        })
      }

      list.push({
        name: 'inforCard',
        caption: this.$t('vrlounge.contactInfo'),
        hidden: !this.currentBuilding.showContactInfo,
        group: 'contactArea',
        method: () => {
          if (!this.customBranding) {
            window.open('https://www.istaging.com', '_blank')
            return
          }
          this.$refs.ModalProfile.show()
          this.closeFloatMenu()
        }
      }, {
        name: 'talk',
        caption: this.$t('IMServe'),
        hidden: !this.currentBuilding.instantMessagingEnable,
        group: 'contactArea',
        method: () => {
          this.closeFloatMenu()
          if (!this.isLogin) {
            this.setCurrentModal(MODALS.login)
            return
          }
          this.toggleChatbox()
        }
      })
      return list.filter((item) => !item.hidden)
    },

    navPcGruopedList () {
      return Object.values(_.groupBy(this.navPcList, 'group'))
    },

    isHideShare () {
      return this.isUiMode || queryString.hideShare
    },
    isHideLocation () {
      return this.isUiMode
    },
    isHideVrmode () {
      return !this.canDeviceSupportGyro || queryString.hideVRMode
    },
    isHideGyro () {
      return !this.canDeviceSupportGyro || queryString.hideGyro
    },
    isHeadsetDevice () {
      return isHeadset()
    },
    isHideFullscreen () {
      return (
        (isIframe() && isMobile() && isIOS()) ||
        (!isIframe() && queryString.hideFullscreen) ||
        (isIframe() && !queryString.showFullscreen)
      )
    },
    isHideMusic () {
      return !this.audioEl
    },
    isHideComment () {
      if (this.social && this.showComment) {
        if (this.isUiMode) return true
        if (this.isChina) return true
        if (isIframe()) return !queryString.showComment
        if (queryString.hideComment) return true
      }
      return true
    },
    isHideSearch () {
      return (
        !(this.social || this.showSearch) ||
        this.isUiMode ||
        this.$isChina ||
        (!isIframe() && queryString.hideSearch) ||
        (isIframe() && !queryString.showSearch)
      )
    },
    isHideLike () {
      return (
        !this.social || this.isUiMode || this.$isChina || queryString.hideLike
      )
    },
    isHideWebsite () {
      return !this.currentBuilding.advertiseLink
    },
    isHideFloorplan () {
      return !(this.floorplan && this.floorplan !== 'none')
    },
    isHidePilot () {
      return (
        !_.isNil(this.$route.query.recordPilot) || _.isEmpty(this.pilotList)
      )
    },
    shouldUseMapIcon () {
      return (
        !_.isNil(this.$route.query.recordPilot) ||
        !_.isNil(this.$route.query.pilot)
      )
    },

    isHideMobileSidebarButton () {
      return this.navMobileInnerList.every((item) => item.hidden)
    }
  },

  watch: {
    isVrMode (newVal) {
      if (isIframe() && this.isGyroFromIframe && isIOS()) {
        if (newVal) {
          this.startGyro()
        } else {
          this.stopGyro()
        }
      }
    },
    isFloatMenuActive (newVal) {
      if (!newVal && this.isPilotTooltipActive) {
        this.closePilotTooltip()
      }
    },
    isPilotPlayerActive (newVal) {
      if (newVal && this.isFloatMenuActive) {
        this.closeFloatMenu()
      }
    }
  },

  methods: {
    ...mapActions([
      'shrinkPilotPlayer',
      'changeShownPilotTooltipState',
      'showPilotList',
      'closePilotList',
      'showPilotPlayer',
      'toggleChatbox',
      'selectBuilding',
      'closeComments',
      'closeFloorplan',
      'closeLocation',
      'closeMobileMenu',
      'closeMarkerInfo',
      'closePanoramasList',
      'closeInformation',
      'closeShare',
      'enterFullscreen',
      'enterVrMode',
      'pauseAudio',
      'playAudio',
      'showComments',
      'showSearchs',
      'closeSearchs',
      'showLocation',
      'showMobileMenu',
      'startGyro',
      'stopGyro',
      'togglePilotList',
      'toggleFloorplan',
      'toggleGyro',
      'toggleInformation',
      'toggleLocation',
      'togglePanoramasList',
      'toggleShare',
      'updateLikeCount',
      'initSearch',
      'selectPanorama',
      'showPilotTooltip',
      'closePilotTooltip',
      'setPilotTooltipOffset',
      'toggleFloatMenu',
      'closeFloatMenu'
    ]),
    ...mapActions('vrlounge', ['setCurrentModal']),
    ...mapActions({
      logout: 'auth/logout'
    }),
    ...mapActions('favorites', {
      showFavoritesDialog: 'showDialog',
      destroyFavorites: 'destroy'
    }),
    showFloatMenu () {
      this.toggleFloatMenu()
      this.$nextTick(() => {
        if (!this.alreadyShownPilotTooltip) {
          const pilotDom = document.getElementById('pilot-pc-id')
          if (pilotDom !== null) {
            const { height, top, left } = pilotDom.getBoundingClientRect()
            this.setPilotTooltipOffset({ x: left - 10, y: top + height / 2 })
            this.showPilotTooltip()
          }
        }
      })
    },
    doLogout () {
      this.$mixpanel.stop()
      this.logout()
      this.destroyFavorites()
      webStorage.removeItem(`session-token-${process.env.NODE_ENV}`)
    },
    toggleAudioStatus () {
      if (!this.audioEl) {
        return
      }
      if (this.audioEl.paused) {
        this.playAudio()
      } else {
        this.pauseAudio()
      }
    },

    changeColor (key = '', value = '') {
      if (!this.icon[key]) {
        return
      }
      this.icon[key].color = value
      if (key === 'pilot') {
        if (value === this.mainColor) {
          this.pilotIconHovered = true
        } else if (value === this.defaultColor) {
          this.pilotIconHovered = false
        }
      }
    },

    getDeviceMotionPermission () {
      if (
        window.DeviceMotionEvent &&
        typeof window.DeviceMotionEvent.requestPermission === 'function'
      ) {
        // handle iOS 13+ devices
        return window.DeviceMotionEvent.requestPermission()
          .then((permissionState) => {
            if (permissionState === 'granted') {
              return true
            }
          })
          .catch(() => {
            return false
          })
      } else {
        // handle regular non iOS 13+ devices
        return true
      }
    },

    searchIconClick () {
      this.initSearch()
      this.showSearchs()
    },
    homeIconClick () {
      this.closeFloatMenu()
      if (this.currentPanorama.objectId !== this.panoramas[0].objectId) {
        this.$mixpanel.track('Change Panorama', {
          buildingId: this.panoramas[0].buildingId,
          objectId: this.panoramas[0].objectId
        })

        this.selectPanorama(this.panoramas[0])
        this.closeInformation()
        this.closeShare()
        this.closeMarkerInfo()
        this.closeLocation()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.menu-group-last-item-line{
  display: block;
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.16);
  padding: 0;
  margin: 16px 0;
}

.item-caption{
  width: 100%;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.25px;
  padding: 8px 0;
}

.chat-box {
  pointer-events:auto
  position: fixed;
  z-index: 99;
  right: 0;
  bottom: 20px;
  width: 360px;
  height: 90vh
  max-height: 600px;
  background-color: #FFF;

  @media (max-width: $response-xs) {
    left: 0;
    bottom: 40px;
    margin: 0 auto;
  }

  @media (min-width: $response-xs){
    right: 16px
  }
}

.menu-item-area-border-bottom{
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}

.i-repeat-li:last-child .menu-item-area-border-bottom{
  border-bottom: none;
}

.menu-item-area{
  width: 100%
  height: 100%
  padding: 4px 16px;
  align-items: flex-start;
  align-self: stretch;
  cursor: pointer;
}

.menu-item-area:hover{
  background: rgba(255, 255, 255, 0.10);
}

.expand-btn{
  color: #FFF;
}

.i-nav {
  position: relative
  height: 100%
}

.i-nav-mobile-inner-active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 200px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
  pointer-events: none;
}

.i-nav-mobile-inner {
  @extend .absolute-full
  display: flex
  justify-content: space-between
  flex-direction: column
  position: relative
  background-color: #FFF
  pointer-events: auto
  transform: translateX(-100%)
  transition: transform .25s cubic-bezier(0, 1, .63, 1)
  padding: 16px 0px 48px 0px
  .nav-list {
    padding-top: 10px;
    overflow: scroll;
  }
  .i-repeat-a {
    font-size: inherit
  }

  .i-repeat-text {
    @extend .text-with-gray-bg
    text-align: left;
    width: 100%
  }

  >>> .i-repeat-li {
    position: relative
    height: 3.5rem
    overflow: hidden
    &:nth-child(12) {
    height: 4.7rem
  }
  }
}

.i-nav-mobile-inner-active {
  transform: none
}

.i-repeat-icon-wrapper {
  @extend .flex-center
  position: relative
  padding-right: 12px
}

.i-nav-policy {
  font-size: 12px

  li {
    a {
      display: block
      padding: 0 16px
      line-height: 2.5rem
      span {
        color: rgba(0, 0, 0, 0.6)
        text-shadow: none
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        letter-spacing: 0.25px;
      }
    }
  }
}

.i-nav-pc {
  display: none
}

@media (min-width: $response) {
  .i-nav {
    width: 300px
    height: 100%
  }

  .i-nav-mobile-inner {
    display: none
  }

  .i-nav-pc-tooltip {
    @extend .text-with-gray-bg
    white-space: nowrap
    pointer-events: none
    position: absolute
    right: $i-main-i-nav-pc-tooltip-pos
    margin-right: $i-main-i-nav-pc-tooltip-margin
    text-align: $i-main-i-nav-pc-tooltip-text-align
    font-size: 12px
    line-height: 17px
    padding: 3px 5px
    background-color: alpha($dark-gray, 80%)
    opacity: 0
    transform: translateX(-3px)
    transition: opacity .1s ease-out, transform .1s ease-out

    &::after {
      content: ''
      display: block
      position: absolute
      left: $i-main-i-nav-pc-tooltip-after-pos
      width: 0
      height: 0
      border-style: solid
      top: 0
      right: $i-main-i-nav-pc-tooltip-pos
      bottom: 0
      border-color: $i-main-i-nav-pc-tooltip-after-border-color
      border-width: 11.5px
    }
  }

  .i-nav-pc-li-inner {
    display: flex
    align-items: center
  }

  .i-nav-pc-icon-wrapper::-webkit-scrollbar {
    width: 6px;
  }

  .i-nav-pc-icon-wrapper::-webkit-scrollbar-thumb{
    background-color: rgba(255, 255, 255, 0.38);
    border-radius: 20px;
  }
  .i-nav-pc-icon-wrapper::-webkit-scrollbar-track {
    background-color: transparent;
  }

  .i-nav-pc-icon-wrapper {
    background-color: #4C4C4C;
    position: absolute;
    top: 75px;
    right: -18px;
    width: 280px;
    border-radius: 10px 4px 4px 10px;
    color: #FFF;
    z-index: 99;
    max-height: 400px;
    overflow-y: scroll;
    padding: 16px 0px 24px 0px;
  }

  .i-nav-pc {
    position: relative
    display: flex
    justify-content: flex-end
    margin: 0
    height: 100%
    width: 100%

    .i-nav-pc-search-wrapper {
    width: 60px
    position: absolute
    display: flex
    flex-direction: column
    align-items: center
    top: 28px
    pointer-events: auto

    .search-icon {
    cursor pointer
  }
  }

    .i-nav-pc-home-wrapper{
      position: absolute
      display: flex
      flex-direction: column
      align-items: center
      top: 24px
      right: 54px
      pointer-events: auto
      color: #FFF
      font-size: 24px
      padding: 10px
      border-radius: 22px
      background-color: rgba(0, 0, 0,.3);
      cursor: pointer
    }

    .i-nav-pc-home-wrapper:hover{
      background-color: rgba(0, 0, 0, 0.4)
    }

    .i-nav-pc-expand-wrapper{
      position: absolute
      display: flex
      flex-direction: column
      align-items: center
      top: 24px
      pointer-events: auto
      background-color: rgba(0, 0, 0,.3);
      padding: 10px
      border-radius: 22px
      font-size: 24px
      cursor: pointer
    }
    .i-nav-pc-expand-wrapper:hover{
      background-color: rgba(0, 0, 0, 0.4)
    }

    .i-nav-pc-expand-wrapper.active{
      background-color: rgba(0, 0, 0, 0.46);
    }

    .i-repeat-icon-wrapper {
      border-radius: 5px
    }

    .i-repeat-a {
      &:hover {
        + .i-nav-pc-tooltip {
          opacity: 1
          transform: none
        }
      }
    }

    .i-repeat-a {
      width: auto;
      font-size: 12px
      line-height: 20px
    }

    .i-repeat-icon {
    $w = 22px
    $h = 22px
    $p = 6.5px
    //width: $w + $p * 2
    //height: $h + $p * 2
    }

    >>> .i-repeat-li {
      pointer-events: auto

      + .i-repeat-li {
    }
    }
  }
}
@media (max-width: 1024px) {
  .menu-item-area-border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.16)
  }

  .menu-item-area:hover{
    background: rgba(0, 0, 0, 0.10);
  }
}
</style>

<style lang="stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  .icon-close-menu {
    transform: rotateY(180deg)
  }

  .i-nav-mobile-inner {
    transform: translateX(-($i-nav-i-nav-mobile-inner-animate-x))
  }

  .i-nav-mobile-inner-active {
    transform: none
  }

  .i-nav-mobile-inner .i-repeat-text {
    margin-right: $i-nav-i-nav-mobile-inner-i-repeat-text-margin
    margin-left: auto
  }

  @media (min-width: $response) {
    .i-nav-pc-tooltip {
      right: auto
      left: $i-main-i-nav-pc-tooltip-pos
      margin-left: $i-main-i-nav-pc-tooltip-margin
      margin-right: auto
      text-align: $i-main-i-nav-pc-tooltip-text-align-rtl

      &::after {
      left: $i-main-i-nav-pc-tooltip-pos
      right: $i-main-i-nav-pc-tooltip-after-pos
      border-color: $i-main-i-nav-pc-tooltip-after-border-color-rtl
    }
    }
  }
}
</style>
